
import InputWrapper from '@/components/common/InputWrapper.vue'
import InputText from '@/components/common/InputText.vue'
import InputDate from '@/components/common/InputDate.vue'
import InputCheck from '@/components/common/InputCheck.vue'
import InputTextArea from '@/components/common/InputTextArea.vue'

import { useApi } from '@/lib/api'
import { defineComponent, ref, getCurrentInstance } from 'vue'
import { errorMap } from '@/lib/filters'
import { useRoute } from 'vue-router'
import { useAppViewedList } from '@/lib/common'

export default defineComponent({
  components: { InputWrapper, InputText, InputDate, InputTextArea, InputCheck },
  setup() {
    const { setRecord } = useAppViewedList()
    const _api = useApi()
    const _route = useRoute()
    const _inst = getCurrentInstance()
    const data = ref({})

    const getData = async () => {
      const res = await _api.get<any>('adminNews?id=' + _route.params.id)
      data.value = res.data
      setRecord('adminNewsList' + _route.params.id)
    }

    const submit = async () => {
      const res = await _api.post<any>('adminNewsWrite', data.value)
      if (res.status === 200) {
        _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Novica shranjena.' })
        data.value = res.data
      }
    }

    if (_route.params.id !== '-1') {
      getData()
    }

    return { data, errorMap, submit }
  }
})
